/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // Npm: Apollo client for handling graphql request.

/*
 * EXPORTS
 */
export default gql`
  mutation ScriptUpdateMutation(
    $scriptId: ID!
    $scriptCode: String!
    $name: String!
  ) {
    ScriptUpdate(
      scriptId: $scriptId
      scriptCode: $scriptCode
      name: $name
    ) {
      createdAt
      id
      message
      name
      scriptCode
      status
      _totalCount
    }
  }
`;
